import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../services/auth.guard';
import { ProfileResolverService } from '../services/profile-resolver.service';
import { OptionsResolverService } from '../services/options-resolver.service';

import { SearchComponent } from './search.component';
import { DecisionsComponent } from './decisions/decisions.component';
import { DocumentsComponent } from './documents/documents.component';
import { ProceedingsComponent } from './proceedings/proceedings.component';

const routes: Routes = [
  {
    path: '',
    component: SearchComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        canActivateChild: [AuthGuard],
        children: [
          {
            path: '',
            redirectTo: 'decisions'
          },
          { path: 'decisions', component: DecisionsComponent, resolve: {
            profile: ProfileResolverService,
            options: OptionsResolverService
          }},

          { path: 'documents', component: DocumentsComponent, resolve: {
            profile: ProfileResolverService,
            options: OptionsResolverService
          }},

          { path: 'proceedings', component: ProceedingsComponent, resolve: {
            profile: ProfileResolverService,
            options: OptionsResolverService
          }}
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SearchRoutingModule { }
